<template>
  <v-row no-gutters>
    <v-col v-if="canShowDisciplineField" cols="12">
      <SelectPicker
        v-model="newSession.discipline"
        subtitle="Discipline"
        :items="disciplines"
        icon="mdi-lead-pencil"
        :return-object="true"
        :select-item="selectItem"
      />
    </v-col>
  </v-row>
</template>

<script>
import { inject, computed, ref } from '@vue/composition-api';
import { repriseSessionType } from '@/helpers/utils';

import SelectPicker from '@/components/common/Form/SelectPicker.vue';

import store from '@/store';

export default {
  components: { SelectPicker },
  setup () {
    const newSession = inject('newSession');

    const sessionType = computed(() => newSession.value.type);

    const canShowDisciplineField = computed(() => repriseSessionType.includes(sessionType.value));

    const disciplines = computed(() => store.state.disciplines.map(d => ({ uuid: d.uuid, wtitle: d.name })));

    const selectItem = ref({
      value: 'uuid',
      label: 'wtitle'
    });

    return { newSession, canShowDisciplineField, disciplines, selectItem };
  }
};

</script>
